import React, { useEffect, useState } from "react";
import "./videos.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import axios from "axios";

const Videos = () => {
  const [videos, setVideos] = useState([]);

  const handleVideo = async () => {
    try {
      const response = await axios.get(
        "https://campaign.sambhajipatilnilangekar.com/wp-json/wp/v2/posts",{
          params: {
            per_page: 100,
            categories: 3, 
          },
        }
      );
      setVideos(response.data);
     
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  useEffect(() => {
    handleVideo();
  }, []);

  return (
    <div className="vid-section-parent parent">
      <h2>Video Gallery</h2>
      <Swiper
        slidesPerView={4} 
        spaceBetween={30}
        navigation={true}
        modules={[Navigation, Pagination]}
        pagination={{
          clickable: true,
        }}
        breakpoints={{
        
          1200: {
            slidesPerView: 4, 
            spaceBetween: 20,
          },
          992: {
            slidesPerView: 3, 
            spaceBetween: 15,
          },
        
          768: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
        
          576: {
            slidesPerView: 1,
            spaceBetween: 5,
          },
          300: {
            slidesPerView: 1,
            spaceBetween: 5,
          },
        }}
        className="mySwiper"
      >
        {videos.length > 0 ? (
          videos.map((video) => (
            <SwiperSlide key={video.id}>
              <div className="video-box">
                <div
                  className="first-box"
                  dangerouslySetInnerHTML={{ __html: video.content.rendered }}
                ></div>
              </div>
            </SwiperSlide>
          ))
        ) : (
          <div className="no-video">No videos available</div>
        )}
      </Swiper>
    </div>
  );
};

export default Videos;
